import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './e9ddd2f338caa1d50c0890aa93313190bf1d0ffbca6850e0ef678074f1f1e039.cfe-internal.js';
import { useRadioGroupContext } from './dc2dcd19156b71f7876c04b437232bc71c237257519b4d21de74e3f9b9474ebe.cfe-internal.js';
import { useFormFieldContext } from '../FormField/f390dafefe74ba07f7da711a77443b7b51d96a6ad1aee47361fd1804064e9ba7.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import concatIds from '../../utils/concatIds/99a67648a55cf7a2ee84ef14be5ebb23af1b4b19b5520388cd5eef8f3f3a1e28.cfe-internal.js';

var _excluded = ["id", "className", "disabled", "value", "aria-label", "aria-labelledby", "aria-describedby", "onChange", "checked", "defaultChecked", "inputProps"];
var Radio = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _ref2;
  var id = _ref.id,
    className = _ref.className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    value = _ref.value,
    ariaLabel = _ref['aria-label'],
    ariaLabelledBy = _ref['aria-labelledby'],
    externalAriaDescribedBy = _ref['aria-describedby'],
    radioOnChange = _ref.onChange,
    radioChecked = _ref.checked,
    radioDefaultChecked = _ref.defaultChecked,
    inputProps = _ref.inputProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useRadioGroupContext = useRadioGroupContext(),
    name = _useRadioGroupContext.name,
    radioGroupOnChange = _useRadioGroupContext.onChange,
    groupDefaultValue = _useRadioGroupContext.groupDefaultValue,
    groupValue = _useRadioGroupContext.groupValue;
  var _useFormFieldContext = useFormFieldContext(),
    formFieldHelperTextId = _useFormFieldContext.helperTextId,
    formFieldErrorTextId = _useFormFieldContext.errorTextId;
  var internalAriaDescribedby = concatIds(externalAriaDescribedBy, formFieldHelperTextId, formFieldErrorTextId, inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-describedby']);
  var checked = groupValue !== undefined ? value === groupValue : radioChecked !== null && radioChecked !== void 0 ? radioChecked : inputProps === null || inputProps === void 0 ? void 0 : inputProps.checked;
  var defaultChecked = groupDefaultValue !== undefined ? value === groupDefaultValue : radioDefaultChecked !== null && radioDefaultChecked !== void 0 ? radioDefaultChecked : inputProps === null || inputProps === void 0 ? void 0 : inputProps.defaultChecked;
  var onChange = (_ref2 = radioGroupOnChange !== null && radioGroupOnChange !== void 0 ? radioGroupOnChange : radioOnChange) !== null && _ref2 !== void 0 ? _ref2 : inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange;
  return /*#__PURE__*/React__default.createElement("span", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles.radio)
  }), /*#__PURE__*/React__default.createElement("input", _extends({}, inputProps, {
    className: classNames(styles.input, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className),
    type: "radio",
    id: id !== null && id !== void 0 ? id : inputProps === null || inputProps === void 0 ? void 0 : inputProps.id,
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled !== null && disabled !== void 0 ? disabled : inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled,
    name: name !== null && name !== void 0 ? name : inputProps === null || inputProps === void 0 ? void 0 : inputProps.name,
    value: value !== null && value !== void 0 ? value : inputProps === null || inputProps === void 0 ? void 0 : inputProps.value,
    onChange: disabled ? undefined : onChange,
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-label'],
    "aria-labelledby": ariaLabelledBy !== null && ariaLabelledBy !== void 0 ? ariaLabelledBy : inputProps === null || inputProps === void 0 ? void 0 : inputProps['aria-labelledby'],
    "aria-describedby": internalAriaDescribedby
  })), /*#__PURE__*/React__default.createElement("span", {
    className: styles.check
  }));
});

export { Radio as default };
